import { z } from 'zod';
import { ExtendedTarificationSchema } from '../tarification/TarificationFormData';
import { ExtendedInsuranceSchema } from './InsuranceFormData';
import { ExtendedOptionsSchema } from './OptionsFormData';
import { ExtendedTaxesSchema } from './TaxesFormData';
import { ExtendedOneWayFeesSchema } from './OneWayFeesFormData';

export const CarCategorySchema = ExtendedTarificationSchema.extend(
  ExtendedInsuranceSchema.shape,
)
  .extend(ExtendedOptionsSchema.shape)
  .extend(ExtendedTaxesSchema.shape)
  .extend(ExtendedOneWayFeesSchema.shape)
  .extend({
    category: z
      .string({ message: 'La catégorie est requise' })
      .min(1, { message: 'La catégorie est requise' }),
    model: z
      .string({ message: 'Le modèle est requis' })
      .min(1, { message: 'Le modèle est requis' }),
    description: z.string().optional(),
    images: z.array(z.union([z.instanceof(Blob), z.string()])),
    maxCapacity: z.coerce.number().int().min(0).optional(),
    maxNbLuggage: z.coerce.number().int().min(0).optional(),
    gearboxType: z.enum(['manual', 'automatic']).optional(),
    airConditioning: z.enum(['true', 'false']).optional(),
    includedMileage: z.coerce.number().int().min(0).optional(),
    isIncludedMileageUnlimited: z.boolean().optional(),
    additionalCost: z.coerce.number().min(0).optional(),
    standardDeductableAmount: z.coerce.number().int().min(0).optional(),
    depositAmount: z.coerce.number().int().min(0).optional(),
    minimumAge: z.coerce.number().int().min(12).optional(),
    included: z.string().optional(),
    notIncluded: z.string().optional(),
    displayCategoryOptions: z.enum(['true', 'false']).optional(),
  });

export const ExtendedCarCategoriesSchema = z.object({
  carCategories: z.array(CarCategorySchema).min(1),
});

export type ExtendedCarCategoriesFormData = z.infer<
  typeof ExtendedCarCategoriesSchema
>;
